<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="updateTaxSettings" id="open_banking_tax_settings_form">
                <kt-form-section>
                    <kt-row>
                        <kt-form-group class="col-12 col-sm-4 col-md-3">
                            <kt-form-group ref="tax_percent">
                                <kt-form-label for="tax_percent">
                                    {{ $t('application.tax_percent') }}
                                </kt-form-label>
                                <kt-form-control
                                    v-model="form_data.tax_percent"
                                    name="tax_percent"
                                    id="tax_percent"
                                ></kt-form-control>
                            </kt-form-group>
                        </kt-form-group>
                        <kt-form-action class="mt-4">
                            <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                type="submit"
                                id="submit_btn_open_banking_tax_settings"
                            >
                                {{ $t('btn.update') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-row>
                </kt-form-section>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import $ from "jquery"
import {KTApp} from '@/plugins/core/app'
import {openBankingService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'

export default {
    name: "TaxSettings",

    data() {
        return {
            form_data: {}
        }
    },
    mounted() {
        openBankingService.adminGetTaxSettings().then(response => {
            this.form_data = response.data.data.data

        }).catch(({response}) => {
            this.showMsg(form, 'danger', response.data.message)
        })
    },
    methods: {
        updateTaxSettings() {

            let form = $('#open_banking_tax_settings_form')
            let btn = $('#submit_btn_open_banking_tax_settings')

            form.validate({
                rules: {
                    tax_percent : {required:true}
                }
            })
            if (!form.valid()) {
                return this.toastr.error(i18n.t('open_banking.message.fill_all'))
            }
            KTApp.progress(btn)

            let params = {
                'tax_percent': this.form_data.tax_percent,
            }

            openBankingService.adminUpdateTaxSettings(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            );
        },
    },
}
</script>

<style scoped>

</style>
